import {
  useGetUserMemberships,
  usePendingOrganizationInvitations
} from "@/api";
import NumerousLogo from "@/components/logo/NumerousLogo";
import { TypographySM } from "@/components/typography/SM";
import { OrganizationCreateLink } from "./OrganizationCreateLink";
import { OrganizationInvitationsError } from "./OrganizationInvitationsError";
import { OrganizationInvitationsList } from "./OrganizationInvitationsList";
import { OrganizationInvitationsLoading } from "./OrganizationInvitationsLoading";
import { OrganizationSelectLink } from "./OrganizationSelectLink";

const OrganizationInvitations = () => {
  const {
    data: invitations,
    loading,
    error
  } = usePendingOrganizationInvitations();
  const { data: memberships, loading: loadingMemberships } =
    useGetUserMemberships();

  if (error) {
    console.error(
      "Failed to fetch user pending organization invitations",
      error
    );
    return <OrganizationInvitationsError />;
  }
  if (loading) return <OrganizationInvitationsLoading />;

  if (invitations.length < 1)
    return (
      <div className="w-full flex flex-col gap-y-2 justify-center items-center">
        <NumerousLogo type="fullLogo" size="sm" className="absolute top-4" />
        <TypographySM className="mb-2">
          You have no pending invitations.
        </TypographySM>
        {!loadingMemberships && memberships.length > 0 && (
          <OrganizationSelectLink />
        )}
        {!loadingMemberships && memberships.length < 1 && (
          <OrganizationCreateLink />
        )}
      </div>
    );

  return (
    <div className="w-full flex flex-col gap-y-2 justify-center items-center">
      <NumerousLogo type="fullLogo" size="sm" className="absolute top-4" />
      <OrganizationInvitationsList invitations={invitations} />
      {!loadingMemberships && memberships.length > 0 && (
        <OrganizationSelectLink />
      )}
      {!loadingMemberships && memberships.length < 1 && (
        <OrganizationCreateLink />
      )}
    </div>
  );
};

export default OrganizationInvitations;
